import { useUIStore } from '#store';
import { Flex, Button } from '@chakra-ui/react';
import { shallow } from 'zustand/shallow';

export default function LoginOptions() {
  const { toggleContactModal, setSteps } = useUIStore(
    (state) => ({
      toggleContactModal: state.toggleContactModal,
      setSteps: state.setSteps,
    }),
    shallow
  );

  const onButtonClick = () => {
    // We don't want to start the checkout flow.
    setSteps([]);
    toggleContactModal(true);
  };

  return (
    <Button variant={'outline'} colorScheme='brand' onClick={onButtonClick} size={['sm', 'md']} mr={[4, 0]}>
      Login / Sign Up
    </Button>
  );
}
